import { createBrowserHistory } from "history";
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { routerMiddleware } from "connected-react-router";
import createRootReducer from "./rootReducer";

export const history = createBrowserHistory();
const rootReducer = createRootReducer(history);
const middleware = [...getDefaultMiddleware(), routerMiddleware(history)];

const store = configureStore({
  reducer: rootReducer,
  middleware,
});

export default store;
